import Vue from "vue";

const EventBus = new Vue();

// EventBus.$on('all', (event, ...args) => {
//   console.log('EventBus:', event, args);
// });

export default EventBus;
